// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgramInfoItems_container__1XFzP","checkmark":"ProgramInfoItems_checkmark__27oMO","item":"ProgramInfoItems_item__8p7br","text":"ProgramInfoItems_text__2mdsM"};